export default __webpack_public_path__ + "static/media/V_Vaso.3a771d77.svg";